export enum MicrositeType {
  personality,
  event,
}
